import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const TabPanelBox = styled(Box, {})({
  display: 'flex',
  padding: 20,

  gap: 20,
  alignItems: 'center',
});
